import Reveal from "@/components/Reveal";
import { Filter } from "lucide-react";

const stages = [
  { n: "01", text: "En qué etapa se encuentra tu consumidor." },
  { n: "02", text: "Qué necesita percibir para avanzar." },
  { n: "03", text: "Qué señal de tu marca puede estar frenando su decisión." },
  { n: "04", text: "Qué acciones podés implementar para mejorar esa etapa." },
];

const widths = ["w-full", "w-[85%]", "w-[70%]", "w-[55%]"];

const Funnel = () => (
  <section className="relative border-t border-white/10 bg-black/30 py-28 md:py-36" data-testid="funnel-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid items-center gap-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <Reveal>
            <p className="mb-6 flex items-center gap-3 text-xs font-medium uppercase tracking-[0.35em] text-neoncyan">
              <Filter className="h-4 w-4" /> El hilo conductor
            </p>
            <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter md:text-5xl">
              Todo conectado con el <span className="text-magenta">funnel</span> de marketing y ventas
            </h2>
            <p className="mt-8 max-w-md text-sm leading-relaxed text-lilac/90 md:text-base">
              Durante todos los módulos vamos a ubicar lo aprendido dentro del funnel,
              para que puedas identificar:
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 hidden flex-col items-start gap-1.5 md:flex" aria-hidden>
              {widths.map((w, i) => (
                <span
                  key={w}
                  className={`h-3 ${w} ${
                    i % 2 === 0 ? "bg-magenta/50" : "bg-neoncyan/40"
                  }`}
                />
              ))}
            </div>
          </Reveal>
        </div>
        <div className="md:col-span-7">
          <ol className="border-t border-white/10">
            {stages.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.07}>
                <li
                  className="group flex items-baseline gap-6 border-b border-white/10 py-6 md:gap-10 md:py-7"
                  data-testid={`funnel-stage-${i + 1}`}
                >
                  <span className="font-display text-sm font-bold text-neoncyan/80 transition-colors duration-300 group-hover:text-magenta">
                    {s.n}
                  </span>
                  <span className="font-editorial text-xl italic text-rosewhite/90 transition-transform duration-500 group-hover:translate-x-3 md:text-3xl">
                    {s.text}
                  </span>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </div>
  </section>
);

export default Funnel;
